import React from "react";

/**
 * Textarea Component
 * Reusable textarea field with consistent styling matching original CSS
 * 
 * @param {string} name - Textarea name
 * @param {string} value - Textarea value
 * @param {string} placeholder - Textarea placeholder
 * @param {function} onChange - Change handler
 * @param {number} rows - Number of rows
 * @param {boolean} error - Error state
 * @param {string} errorMessage - Error message to display
 * @param {string} className - Additional classes
 */
const Textarea = ({
  name,
  value,
  placeholder,
  onChange,
  rows = 8,
  error = false,
  errorMessage,
  className = "",
  ...props
}) => {
  return (
    <div className="mb-3">
      <textarea
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        rows={rows}
        className={`w-full p-3 font-roboto font-normal text-[0.731rem] leading-[0.688rem] text-[#808080] resize-none border ${
          error ? "border-[#EF5464]" : "border-[#808080]"
        } rounded-[0.3rem] focus:outline-none ${className}`}
        {...props}
      />
      {error && errorMessage && (
        <p className="m-0 text-[#EF5464] text-[0.60rem] py-[5px] whitespace-nowrap">
          {errorMessage}
        </p>
      )}
    </div>
  );
};

export default Textarea;
